import { useSelector } from "react-redux";
import React, { useState } from "react";
import { API_VMS } from "../constants";

const Menu = [
  { is_header: true },
  { path: "/dashboard", icon: "bi bi-columns", title: "Dashboard" },
  {
    path: "/laporan",
    icon: "fas fa-file-alt",
    title: "Laporan",
    children: [
      {
        path: "/laporan/people-detection",
        title: "Pendeteksi Perhitungan Orang",
      },
      { path: "/laporan/lean-detection", title: "Pendeteksi Bersandar" },
      { path: "/laporan/jump-detection", title: "Pendeteksi Melompat" },
    ],
  },
  { path: "/lokasi", icon: "fas fa-map-marker-alt", title: "Lokasi" },
  {
    path: "/deteksi-langsung",
    icon: "fas fa-object-group",
    title: "Deteksi Langsung",
    children: [
      { path: "/live-detection-people", title: "Pendeteksi Perhitungan Orang" },
      { path: "/live-detection-lean", title: "Pendeteksi Bersandar" },
      { path: "/live-detection-jump", title: "Pendeteksi Melompat" },
    ],
  },
  {
    path: "/smart-parking",
    icon: "fas fa-camera",
    title: "Sistem Manajemen Vidio",
    children: [
      { path: `http://${API_VMS}/dashboard`, title: "CCTV Langsung" },
      { path: `http://${API_VMS}/record`, title: "Rekaman Vidio" },
      { path: `http://${API_VMS}/lift-Controlling`, title: "CCTV LIFT" },
    ],
  },
  {
    path: "/user-managment",
    icon: "fas fa-users",
    title: "Manajemen Pengguna",
    children: [
      { path: "/user-managment/user", title: "User" },
      { path: "/user-managment/role", title: "Role" },
    ],
  },
  {
    path: "/data-master",
    icon: "far fa-folder-open",
    title: "Master Data",
    children: [
      { path: "/data-master/sites", title: "Sites" },
      { path: "/data-master/camera", title: "Camera" },
      { path: "/data-master/analytic", title: "Analytik" },
      { path: "/data-master/device", title: "Device" },
      { path: "/data-master/units", title: "Units" },
      { path: "/data-master/sensor", title: "Sensor" },
    ],
  },
];


export default Menu;
